<template>
  <div class="home" ref="scaleRef">
    <div class="header">
      <div class="headContent">
        <div class="headLeft">
          <div class="zzjgt" @click="isShowZzjgt=true">
            <img src="@/assets/images/newHome/zzjgt-icon.png" alt="">
            <span>组织结构图</span>
          </div>
        </div>
        <div class="headTitle">平安堆龙社区治理信息化管理平台</div>
        <div class="headRight">
          <div class="tz" @click="$router.push('/gzt/gzt')">
            <img src="@/assets/images/newHome/tz-icon.png" alt="">
            <div class="spot">{{ gztWclNum }}</div>
          </div>
          <div class="userName" @click="$router.push('/user/center')">
            <img v-if="$store.state.user.currentInfoUserData.avatar" :src="imageUrlprefix+$store.state.user.currentInfoUserData.avatar" alt="">
            <img v-else src="@/assets/images/newHome/user-icon.png" alt="">
            <span class="textFillColor">{{ $store.state.user.currentInfoUserData.name }}</span>
            <!-- <img src="@/assets/images/newHome/arrows-icon.png" alt=""> -->
          </div>
          <div class="tc">
            <img src="@/assets/images/newHome/close-icon.png" alt="">
            <span class="textFillColor" @click="logout">退出</span>
          </div>
        </div>
      </div>
    </div>

    <div class="main">
      <div class="left">
        <!-- 党建引领 -->
        <div class="commonBox djyl">
          <div class="commonTitle">
            <div class="titleContent">
              <img src="@/assets/images/newHome/djyl-icon.png" alt="">
              <span class="textFillColor">党建引领</span>
            </div>
          </div>
          <div class="commonContent djylContent">
            <div :key="item.name" class="djylItem" v-for="item in djyl">
              <div class="djylTitle">
                <img :src="item.icon" alt="">
                <div class="djylTitleRight">
                  <div class="name textFillColor">{{ item.name }}</div>
                  <span class="textFillColor">
                   <myNnumberRoll :number="item.num" :delay="1.3"></myNnumberRoll>
                  </span>
                </div>
              </div>
              <div class="djylBottom">
                <djylHxtChart :chartName="item.name" :chartData="item.data"></djylHxtChart>
              </div>
            </div>
          </div>
        </div>

        <!-- 综治力量 -->
        <div class="commonBox zzll">
          <div class="commonTitle">
            <div class="titleContent">
              <img src="@/assets/images/newHome/zzll-icon.png" alt="">
              <span class="textFillColor">综治力量</span>
            </div>
          </div>
          <div class="commonContent zzllContent">
            <div class="zzllTitle">
              <div class="zzjg">
                <span class="textFillColor">综治机构</span>
                <img src="@/assets/images/newHome/zzjg-icon.png" alt="">
              </div>
              <div class="zzdw">
                <img src="@/assets/images/newHome/zzdw-icon.png" alt="">
                <span class="textFillColor">综治队伍</span>
              </div>
            </div>
            <div class="zzllBottom">
              <div class="left">
                <div class="leftItem" v-for="(item,index) in zzll.zzjg_cj_jsons" :key="index">
                  <div class="count textFillColor">
                    <myNnumberRoll :number="item.count" :delay="1"></myNnumberRoll>
                  </div>
                  <div class="name">{{ item.mc }}</div>
                </div>
              </div>
              <div class="right">
                <div class="rightItem" v-for="(item,index) in zzll.zzjgdw_cj_jsons" :key="index">
                  <div class="name">{{ item.mc }}</div>
                  <div class="count textFillColor">
                    <myNnumberRoll :number="item.count" :delay="1"></myNnumberRoll>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 社会力量 -->
        <div class="commonBox shll">
          <div class="commonTitle">
            <div class="titleContent">
              <img src="@/assets/images/newHome/shll-icon.png" alt="">
              <span class="textFillColor">社会力量</span>
            </div>
          </div>
          <div class="commonContent shllContent">
            <div class="shllItem" v-for="(item,index) in shllList" :key="index">
              <img :src="item.icon" alt="">
              <div class="shllItemRight">
                <span>
                  <myNnumberRoll :number="item.num" :delay="0.5"></myNnumberRoll>
                </span>
                <div>{{ item.name }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="content">
        <!-- 地图 -->
        <div class="map">
          <div class="mapControl">
            <div class="mapCurrent" v-if="mapActive == '堆龙德庆区'"></div>
            <div class="mapCurrent2" v-if="mapActive == '乃琼社区'"></div>
            <div :style="[{ backgroundImage: 'url(' + (mapActive == '堆龙德庆区' ? mapActiveIcon : unMapActiveIcon) + ')' }]"
              @click="mapActive = '堆龙德庆区'" style="width: 96px">
              堆龙德庆区
            </div>
            <div :style="[{ backgroundImage: 'url(' + (mapActive == '乃琼社区' ? mapActiveIcon : unMapActiveIcon) + ')' }]"
              @click="mapActive = '乃琼社区'" style="width: 79px;margin-top:10px;">
              乃琼社区
            </div>
          </div>

          <div class="mapContent">
            <!-- 堆龙德庆区地图 -->
            <template v-if="mapActive == '堆龙德庆区'">
              <img alt="" class="dldqMap" src="@/assets/images/home/map1.png">
              <div class="mapDz">
                <img class="mapDzGuang" src="@/assets/images/home/mapBottom2.png">
                <img class="mapBottom" src="@/assets/images/home/mapBottom1.png">
              </div>
             
            </template>
            <!-- 乃琼社区地图 -->
            <img alt="" class="nqsqMap" src="@/assets/images/home/map2.png" v-if="mapActive == '乃琼社区'">

          </div>


          <div class="contentTab">
            <img class="leftJt" @click="tabLeftClick" src="@/assets/images/newHome/tabLeft.png" alt="">
            <img class="rightJt" @click="tabRightClick" src="@/assets/images/newHome/tabRight.png" alt="">
            <div :key="index" :style="[{ backgroundImage: 'url(' + (active == item ? activeTabe : unActiveTabe) + ')' }]"
              @click="tabClick(item, index)" @mouseenter="tabItemMouseOver(item)"  @mouseleave="tabItemMouseOut(item)" class="tabItem" v-for="(item, index) in routesGroups[tabGroupIndex]" v-show="!item.hidden">
              <!-- 图标 -->
              <i class="icon" v-if="item.meta.icon && item.meta.icon.indexOf('.')==-1" :class="item.meta ?  item.meta.icon : item.children[0].meta.icon" alt=""></i>
              <!-- 图片 -->
              <img class="icon" v-else :src="imageUrlprefix + item.tabItemIcon" alt="">
              <span :class="active == item ? '' : ''" v-if="item.meta && item.meta.title">{{ item.meta.title }}</span>
            </div>
          </div>
        </div>
        
        <!-- 处置调度 -->
        <div class="commonBox czdd">
          <div class="commonTitle">
            <div class="titleContent">
              <img src="@/assets/images/newHome/czdd-icon.png" alt="">
              <span class="textFillColor">处置调度</span>
            </div>
          </div>
          <div class="czddContent">
            <div class="czddLeft">
              <div class="jzr">
                <span>今日新增</span>
                <div style="text-align: right;">
                  +<myNnumberRoll :number="czddData.sj_count_xz" :delay="0.5"></myNnumberRoll>
                </div>
              </div>
              <div class="czddLeftTop">
                <div class="sjzs">
                  <span class="textFillColor">
                    <myNnumberRoll :number="czddData.sj_count" :delay="0.8"></myNnumberRoll>
                  </span>
                  <div>事件总数</div>
                </div>
              </div>
              <div class="czddLeftBottom">
                <div class="czddLeftBottomItem" v-for="(item,index) in czddLeftList" :key="index">
                  <div class="left">
                    <span>{{ item.name }}</span>
                    <div>
                      <myNnumberRoll style="color:#24F0E4;" :number="item.num" :delay="0.8"></myNnumberRoll>
                    </div>
                  </div>
                  <div class="right">
                    <span>今日新增</span> 
                    <div>
                      +<myNnumberRoll style="color: #F02430;" :number="item.xzNum" :delay="0.8"></myNnumberRoll>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="czddRight">
              <div class="czddRightTop">
                <czddHxtChart  ref="czddHxtChartRef"></czddHxtChart>
              </div>
              <div class="czddRightBottom">
                <div class="czddTabs">
                  <span :key="index"
                    :style="[{ backgroundImage: 'url(' + (czddActive == index ? czddActiveIcon : unCzddActiveIcon) + ')' }]"
                    @click="czddActiveClick(item,index)" v-for="(item,index) in czddTimeTypeList"> {{ item.name }}</span>
                </div>
                <zhexianChart ref="zhexianChartRef"></zhexianChart>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="right">
        <!-- 基础数据9+X -->
        <div class="commonBox jcsj">
          <div class="commonTitle">
            <div class="titleContent">
              <img src="@/assets/images/newHome/jcsj-icon.png" alt="">
              <span class="textFillColor">基础数据9+X</span>
            </div>
          </div>
          <div class="commonContent jcsjContent">
            <!-- 基础数据9 -->
            <div class="jcsj9">
              <div class="jcsj9Item" style="z-index: 9;">
                <div class="shzzList list">
                  <div class="shzzListItem item" v-for="(item,index) in jcsjList9.shzzList" :key="index">
                    <div class="num">
                      <myNnumberRoll :number="item.num" :delay="1.3"></myNnumberRoll>
                    </div>
                    <div class="name">{{ item.name }}</div>
                    <!-- <img class="leftLine" :src="item.lineImg" alt=""> -->
                  </div>
                </div>
                <img src="@/assets/images/newHome/jcsj9/shzz-line.png" alt="">
              </div>
              <div class="jcsj9Item" id="jcsj9ItemZzjg">
                <div class="zzjgList list">
                   <div class="zzjgListItem item" v-for="(item,index) in jcsjList9.zzjgList" :key="index">
                    <div class="num">
                      <myNnumberRoll :number="item.num" :delay="1.3"></myNnumberRoll>
                    </div>
                    <div class="name">{{ item.name }}</div>
                   </div>
                 </div>
                 <img src="@/assets/images/newHome/jcsj9/zzjg-line.png" alt="">
              </div>
              <img  class="jcsj9Content" src="@/assets/images/newHome/jcsj9/jcsj9-content.png" alt="">

              <div class="jcsj9Item" id="jcsj9ItemSyrk">
                <img src="@/assets/images/newHome/jcsj9/syrk-line.png" alt="">
                <div class="syrkList list">
                  <div class="syrkListItem item" v-for="(item,index) in jcsjList9.syrkList" :key="index">
                    <div class="name">{{ item.name }}</div>
                    <div class="num">
                      <myNnumberRoll :number="item.num" :delay="1.3"></myNnumberRoll>
                    </div>
                  </div>
                </div>
              </div>
              <div class="jcsj9Item" id="jcsj9ItemHjrk">
                <img src="@/assets/images/newHome/jcsj9/hjrk-line.png" alt="">
                <div class="hjrkList list">
                  <div class="hjrkListItem item" v-for="(item,index) in jcsjList9.hjrkList" :key="index">
                    <div class="name">{{ item.name }}</div>
                    <div class="num">
                      <myNnumberRoll :number="item.num" :delay="1.3"></myNnumberRoll>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <img class="jcsjLine" src="@/assets/images/newHome/jcsj9/jcsj-line.png" alt="">
            <!-- 基础数据x -->
            <div class="jcsjx">
              <div class="jcsjxItem">
                <div class="jcsjxLeftList list">
                  <div class="jcsjxLeftListItem item" v-for="(item,index) in jcsjListx.jcsjxLeftList" :key="index">
                    <div class="num">
                      <myNnumberRoll :number="item.num" :delay="1.3"></myNnumberRoll>
                    </div>
                    <div class="name">{{ item.name }}</div>
                  </div>
                </div>
                <img src="@/assets/images/newHome/jcsjx/jcsjx-left-xian.png" alt="">
              </div>
              <img class="jcsjxContent" src="@/assets/images/newHome/jcsjx/jcsjx-content.png" alt="">
              <div class="jcsjxItem" id="jcsjxItemRight">
                <img src="@/assets/images/newHome/jcsjx/jcsjx-right-xian.png" alt="">
                <div class="jcsjxRightList list">
                  <div class="jcsjxRightListItem item" v-for="(item,index) in jcsjListx.jcsjxRightList" :key="index">
                    <div class="name">{{ item.name }}</div>
                    <div class="num">
                      <myNnumberRoll :number="item.num" :delay="1.3"></myNnumberRoll>
                    </div>
                  </div>
                </div>
              </div>
            </div> 
          </div>
        </div>

        <!-- 风险摸排 -->
        <div class="commonBox fxmp">
          <div class="commonTitle">
            <div class="titleContent">
              <img src="@/assets/images/newHome/fxmp-icon.png" alt="">
              <span class="textFillColor">风险摸排</span>
            </div>
          </div>
          <div class="commonContent pxmpContent">
            <div class="fxmpList">
              <div class="fxmpListItem" v-for="(item,index) in fxmpList" :key="index">
                <div>{{ item.name }}</div>
                <span>
                  <myNnumberRoll :number="item.num" :delay="1"></myNnumberRoll>
                </span>
              </div>
            </div>

            <div class="slh">
              <div class="slhLeftList">
                <div class="slhListItem" v-for="(item,index) in slhList.left" :key="index">
                  <span>
                    <myNnumberRoll :number="item.num" :delay="1"></myNnumberRoll>
                  </span>
                  <div>{{ item.name }}</div>
                </div>
              </div>
              <img src="@/assets/images/newHome/slh-left-xian.png" alt="">
              <div class="slhContent">
                <span>双联户</span>
              </div>
              <img src="@/assets/images/newHome/slh-right-xian.png" alt="">
              <div class="slhRightList">
                <div class="slhListItem" v-for="(item,index) in slhList.right" :key="index">
                  <span>
                    <myNnumberRoll :number="item.num" :delay="1"></myNnumberRoll>
                  </span>
                  <div>{{ item.name }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 数据统计 -->
        <div class="commonBox sjtj">
          <div class="commonTitle sjtjCommonTitle">
            <div class="titleContent sjtjTitleContent">
              <div class="w-100 flex flex-x justify-between">
                <div class="flex flex-x">
                  <img src="@/assets/images/newHome/sjtj-icon.png" alt="">
                  <span class="textFillColor">数据统计</span>
                </div>
                <div class="sjtjTitleRight">
                  <span :key="index" :class="index == sjtjTimeActive ? 'timeActive textFillColor' : ''"
                    @click="sjtjClick(item,index)" style="margin-left: 10px;" v-for="(item,index) in sjtjTimeTypeList">{{ item.name }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="commonContent sjtjContent">
            <div class="sjtjTj">
              <div :key="index" class="sjtjTjItem" v-for="(item, index) in xxcjTjList">
                <img :src="item.icon" alt="">
                <div class="sjtjTjItemRight">
                  <span>{{ item.name }}</span>
                  <div>
                    <myNnumberRoll :number="item.num" :delay="sjtjDelay"></myNnumberRoll>
                  </div>
                </div>
              </div>
            </div>
            <div class="tableHeader">
              <div :key="index" class="textFillColor" v-for="(item, index) in tableHeaderList">
                <span>{{ item }}</span>
                <img src="@/assets/images/newHome/sjtj-header-bj.png" alt="">
              </div>
            </div>
            <div class="tableList">
              <div :key="index" class="flex flex-x justify-around" style="color: #96c2cf;"
                v-for="(item, index) in tableList">
                <span>{{ item.name }}</span>
                <myNnumberRoll :number="item.fw_count" :delay="sjtjDelay"></myNnumberRoll>
                <myNnumberRoll :number="item.rk_count" :delay="sjtjDelay"></myNnumberRoll>
                <myNnumberRoll :number="item.dw_count" :delay="sjtjDelay"></myNnumberRoll>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>

    <!-- 组织结构图 -->
    <zzjgtDialog v-if="isShowZzjgt" :isDialog="isShowZzjgt" @handleClose="isShowZzjgt=false"></zzjgtDialog>
  </div>
</template>

<script>
import scaleMixin from '@/utils/scaleMixin.js'
import djylHxtChart from './modules/djylHxtChart.vue'
import zhexianChart from './modules/zhexianChart.vue'
import czddHxtChart from './modules/czddHxtChart.vue'
import zzjgtDialog from './components/zzjgtDialog.vue'

import {indexGztWclCount,indexDjyl,indexZzll,indexShll,czddSjzt,czddSjfl,czddSjtj,indexJcsj9,indexJcsjx,indexFxmp,indexSjtj} from '@/api/home.js'

export default {
  name: 'HomeView',
  mixins: [scaleMixin],
  components: {
    djylHxtChart,//党建引领
    zhexianChart,//折线
    czddHxtChart,//处置调度环形图
    zzjgtDialog,//组织结构图
  },
  data() {
    return {
      gztWclNum:0,//工作台未处理数量
      // 组织结构图
      isShowZzjgt:false,
      // 基础数据9
      jcsjList9:{
        shzzList:[
          {
            name:'社会组织',
            num:0,
            key:'shzz_count',
          },
          {
            name:'非公组织',
            num:0,
            key:'fgzz_count',
          },
          {
            name:'重点地区',
            num:0,
            key:'zdqy_count',
          },
          {
            name:'命案防控',
            num:0,
            key:'mafk_count',
          },
          {
            name:'寄递物流',
            num:0,
            key:'jdwl_count',
          },
        ],
        zzjgList:[
          {
            name:'综治机构',
            num:0,
            key:'zzjg_count',
          },
          {
            name:'两新组织',
            num:0,
            key:'lxzz_count',
          },
          {
            name:'校园周边',
            num:0,
            key:'xyzb_count',
          },
          {
            name:'社会治安',
            num:0,
            key:'shza_count',
          },
          {
            name:'重点青少年',
            num:0,
            key:'zsqsn_count',
          },
        ],
        syrkList:[
          {
            name:'实有人口',
            num:0,
            key:'syrk_count',
          },
          {
            name:'实有房屋',
            num:0,
            key:'syfw_count',
          },
          {
            name:'护路护线',
            num:0,
            key:'hlhx_count',
          },
          {
            name:'特殊人群',
            num:0,
            key:'tsrq_count',
          },
        ],
        hjrkList:[
          {
            name:'户籍人口',
            num:0,
            key:'hjrk_count',
          },
          {
            name:'流动人口',
            num:0,
            key:'ldrk_count',
          },
          {
            name:'境外人口',
            num:0,
            key:'jwrk_count',
          },
          {
            name:'留守人口',
            num:0,
            key:'lsrk_count',
          },
        ],

      },

      // 基础数据x
      jcsjListx:{
        jcsjxLeftList:[
          {
            name:'党员学习',
            num:0,
            key:'dyxx_count',
          },
          {
            name:'双联户单位',
            num:0,
            key:'slhdw_count',
          },
          {
            name:'关怀人群',
            num:0,
            key:'ghrq_count',
          },
        ],
        jcsjxRightList:[
          {
            name:'风险排查',
            num:0,
            key:'fxpc_count',
          },
          {
            name:'安全生产',
            num:0,
            key:'aqsc_count',
          },
          {
            name:'党群服务',
            num:0,
            key:'dqfw_count',
          },
        ],

      },
      // 风险摸排
      slhList:{
        left:[
          {
            name:'安全隐患排查  ',
            num:0,
            key:'aqyhpc'
          },
          {
            name:'矛盾纠纷排查',
            num:0,
            key:'mdjfpc',
          },
          
        ],
        right:[
          {
            name:'整治',
            num:0,
            key:'zz',
          },
          {
            name:'环境整治',
            num:0,
            key:'hjzz',
          },
        ]
      },
      fxmpList:[  
        {
          name:'双联户单位',
          num:0,
          key:'slhdw_count',
        },
        {
          name:'重点排查区域',
          num:0,
          key:'zdqy_count',
        },
        {
          name:'单位排查',
          num:0,
          key:'dwpc_count',
        },
        // {
        //   name:'重点人口走访',
        //   num:0,
        //   key:'zzrkzf_count',
        // },
        {
          name:'实有人口走访',
          num:0,
          key:'rkzf_count',
        },
      ],
      // 数据统计
      sjtjDelay:0.5,//数字滚动延迟时间
      sjtjTimeActive: 0,
      sjtjTimeTypeList:[
        {
          name:'全部',
          value:0
        },
        {
          name:'日',
          value:1
        },
        {
          name:'周',
          value:7
        },
        {
          name:'月',
          value:30
        },
        {
          name:'年',
          value:360
        },
      ],
      tableHeaderList: [
        '乡镇',
        '房屋数',
        '人口数',
        '单位数',
      ],
      tableList: [],
      //信息统计
      xxcjTjList: [
        {
          name: '房屋数',
          icon:require('@/assets/images/newHome/fws-icon.png'),
          num: 0,
          key:'fw_count',
        },
        {
          name: '人口数',
          icon:require('@/assets/images/newHome/rks-icon.png'),
          num: 0,
          key:'rk_count',
        },
        {
          name: '单位数',
          icon:require('@/assets/images/newHome/dws-icon.png'),
          num: 0,
          key:'dw_count',
        },
      ],

      // 地图
      tabGroupIndex:0,
      mapActive: '堆龙德庆区',
      mapActiveIcon: require('@/assets/images/home/mapActive.png'),
      unMapActiveIcon: require('@/assets/images/home/mapUnActive.png'),

      // 处置调度
      czddActive: 0,
      czddTimeTypeList:[
        {
          name:'最近7天',
          value:7,
        }, 
        {
          name:'最近15天',
          value:15,
        },
        {
          name:'最近30天',
          value:30,
        }
      ],
      czddActiveIcon: require('@/assets/images/home/czddActive.png'),
      unCzddActiveIcon: require('@/assets/images/home/czddUnActive.png'),
      czddCharData: [
        // { value: 201, num: 201, ratio: '37.22%', name: '矛...' },
        // { value: 268, num: 268, ratio: '49.63%', name: '城...' },
        // { value: 71, num: 71, ratio: '13.15%', name: '社会...' },
      ],
      czddData:{},
      czddLeftList: [
        // {
        //   name: '办理中',
        //   num: '193',
        //   xzNum: '2',
        // },
        // {
        //   name: '督办',
        //   num: '2',
        //   xzNum: '0',
        // },
        // {
        //   name: '已办结',
        //   num: '347',
        //   xzNum: '1',
        // },
        // {
        //   name: '退回',
        //   num: '2',
        //   xzNum: '0',
        // },
      ],
      // 社会力量
      shllList:[
        {
          name:'群防群治',
          num:0,
          key:'qfqzzz_count',
          icon:require('@/assets/images/newHome/qfqz-icon.png'),
        },
        {
          name:'群防群治队伍',
          num:0,
           key:'qfqzdw_count',
          icon:require('@/assets/images/newHome/qfqzdw-icon.png'),
        },
        {
          name:'志愿者队伍',
          num:0,
           key:'zyzdw_count',
          icon:require('@/assets/images/newHome/zyzdw-icon.png'),
        },
        {
          name:'志愿者成员',
          num:0,
           key:'zyzdwcy_count',
          icon:require('@/assets/images/newHome/zyzcy-icon.png'),
        },
        {
          name:'街道联户长',
          num:0,
           key:'lhz_count',
          icon:require('@/assets/images/newHome/jdlhz-icon.png'),
        },
        {
          name:'联户家庭',
          num:0,
           key:'lhjtxx_count',
          icon:require('@/assets/images/newHome/lhjt-icon.png'),
        },
      ],
      // 综治力量
      zzll:{
        zzjg_cj_jsons:[
          // {
          //   name:'区级部门',
          //   num:0,
          // },
          // {
          //   name:'街道/乡镇',
          //   num:0,
          // },
          // {
          //   name:'社区/村居',
          //   num:0,
          // },
          // {
          //   name:'网格',
          //   num:0,
          // },
        ],
        zzjgdw_cj_jsons:[
          // {
          //   name:'区领导',
          //   num:0,
          // },
          // {
          //   name:'镇领导',
          //   num:0,
          // },
          // {
          //   name:'村两委',
          //   num:0,
          // },
          // {
          //   name:'网格长',
          //   num:0,
          // },
        ]
      },
      // 党建引领
      djyl: [
        {
          name: '党组织',
          num: 0,
          keyNum:'dzz_total',
          icon: require('@/assets/images/newHome/dzz-icon.png'),
          keyData:'dzz_lx_jsons',
          data: [
            // { value: 1, num: 1, ratio: '14.28%', name: '乃琼街道党支部' },
            // { value: 1, num: 1, ratio: '14.28%', name: '东嘎街道' },
            // { value: 1, num: 1, ratio: '14.28%', name: '羊达街道' },
            // { value: 1, num: 1, ratio: '14.28%', name: '柳梧街道' },
            // { value: 1, num: 1, ratio: '14.28%', name: '古荣街道' },
            // { value: 1, num: 1, ratio: '14.28%', name: '德庆街道' },
            // { value: 1, num: 1, ratio: '14.28%', name: '马镇街道' },
          ]
        },
        {
          name: '党员',
          num: 0,
          keyNum:'dy_total',
          icon: require('@/assets/images/newHome/dy-icon.png'),
          keyData:'dy_lx_jsons',
          data: [
            // { value: '1830', num: '1,830', ratio: '38.28%', name: '农牧民（社...）' },
            // { value: '1130', num: '1,130', ratio: '23.64%', name: '机关事业单...' },
            // { value: '1110', num: '1,110', ratio: '23.22%', name: '两新党员' },
            // { value: '710', num: '710', ratio: '14.85%', name: '离退休党员' },
          ]
        }
      ],
      routes: [],//接口获取路由
      routesGroups: [],//接口获取路由分组（8个1组）
      activeTabe: require('@/assets/images/newHome/tabActive.png'),
      unActiveTabe: require('@/assets/images/newHome/tabUnActive.png'),
      active: '',
      tabList: [

      ],

    }
  },
  created(){
    this.getData();
    // 菜单展示
    let routes = JSON.parse(JSON.stringify(this.$store.state.route.addRoutes))
    this.routes = routes.map(item=>{
      return{
        ...item,
        tabItemIcon:item.meta ? item.meta.iconUnselected:'',//tab菜单图片图标
      }
    })
    const filterRoutes = this.routes.filter(obj => obj.hidden === false);
    this.routesGroups = this.arrGroups(filterRoutes,8)
  },
  methods: {
    // 退出登录
    logout() {
      this.$store.dispatch('LogOut').then(() => {
        this.$router.push("/login")
        localStorage.setItem('isLogout',true)//是否退出登录 true是 false否
        this.$message.success('退出登录成功！')
      })
    },
    //数据统计时间
    sjtjClick(item,index) {
      this.sjtjDelay=0;
      this.sjtjTimeActive = index;
      this.getIndexSjtj(item.value);// 数据统计
    },
    tabLeftClick(){
      console.log(this.tabGroupLength,'tabGroupLength');
      if(this.tabGroupIndex>0){
        this.tabGroupIndex--;
      }else{
        this.$message.warning('没有更多了！')
      }
    },
    tabRightClick(){
      if((this.routesGroups.length-1)>this.tabGroupIndex){
        this.tabGroupIndex++;
      }else{
        this.$message.warning('没有更多了！')
      }
    },
    // 数组分组
    arrGroups(arr, len) {
      if (len <= 1 || arr.length < len) return [arr]
      let groups = [], loop = Math.ceil(arr.length / len)
      for (let i = 0; i < loop; i++)
      groups.push(arr.slice(len * i, len * (i + 1)))
      return groups
    },

     //处置调度切换
     czddActiveClick(item,index) {
      this.czddActive = index
      this.getCzddSjtj(item.value); // 处置调度-事件统计-折线图
    },
    tabClick(item, index) {
      let key = item.path;
      // 把选中路由的子路由保存store
      let allArr = [...this.routes]
      const route = allArr.find(item => item.path === key)
      localStorage.setItem('routeItem', JSON.stringify(route))//保存一级路由
      this.$router.push(this.resolvePath(item));//跳转第一个子路由页面
    },
    //匹配路由路径
    resolvePath(item) {
      // 如果是首页，就返回重定向路由
      if (item.path === '/') {
        const path = '/index'
        return path
      }
      // 如果有子项，默认跳转第一个子项路由
      let path = ''
      /**
       * item 路由子项
       * parent 路由父项
       */
      const getDefaultPath = (item, parent) => {
        // 第一次需要父项路由拼接，所以只是第一个传parent
        if (parent) {
          path += (parent.path + '/' + item.path)
        } else {
          path += ('/' + item.path)
        }
        // 如果还有子项，继续递归
        if (item.children) {
          getDefaultPath(item.children[0])
        }
      }

      if (item.children) {
        getDefaultPath(item.children[0], item)
        return path
      }

      return item.path
    },
    // tab移入
    tabItemMouseOver(item){
      if(item.meta){
        item.tabItemIcon = item.meta.iconSelected
      }else{
        item.tabItemIcon = item.children[0].meta.iconSelected
      }
    },
    // tab移出
    tabItemMouseOut(item){
      if(item.meta){
        item.tabItemIcon = item.meta.iconUnselected
      }else{
        item.tabItemIcon = item.children[0].meta.iconUnselected
      }
    },
    

    // 获取数据
    getData(){
      this.getIndexGztWclCount();// 工作台未处理数量
      this.getIndexDjyl();// 党建引领
      this.getIndexZzll();// 综治力量
      this.getIndexShll();// 社会力量

      this.getCzddSjzt(); // 处置调度-事件状态
      this.getCzddSjfl(); // 处置调度-事件分类
      this.getCzddSjtj(7); // 处置调度-事件统计-折线图

      this.getIndexJcsj9();// 基础数据9
      this.getIndexJcsjx();// 基础数据x
      this.getIndexFxmp();// 风险摸排
      this.getIndexSjtj(0);// 数据统计
    },
    // 工作台未处理数量
    getIndexGztWclCount(){
      indexGztWclCount({}).then(res=>{
        if(res && res.code==200 && res.data){
          this.gztWclNum=res.data.count||0;
        }
      })
    },
    // 党建引领
    getIndexDjyl(){
      indexDjyl({}).then(res=>{
        if(res && res.code==200 && res.data){
          this.djyl.forEach(item=>{
            item.num = res.data[item.keyNum]||0;
            item.data = res.data[item.keyData].map(item=>{
              return{
                name:item.mc,
                value:item.count||0,
                num:item.count||0,
                ratio:item.percentage||0,
              }
            })
          })
        }
      })
    },
    // 综治力量
    getIndexZzll(){
      indexZzll({}).then(res=>{
        if(res && res.code==200 && res.data){
          this.zzll = res.data;

          // for (const key in this.zzll) {
          //   this.zzll[key].forEach(item=>{
          //     res.data[key].forEach(ele=>{
          //       if(item.name == ele.mc){
          //         item.num = ele.count;
          //       }
          //     })
          //   })
          // }
        }
      })
    },
    // 社会力量
    getIndexShll(){
      indexShll({}).then(res=>{
        if(res && res.code==200 && res.data){
          this.shllList.forEach(item=>{
            item.num = res.data[item.key]||0;
          })
        }
      })
    },


    // 处置调度-事件状态
    getCzddSjzt(){
      czddSjzt({}).then(res=>{
        if(res && res.code==200 && res.data){
          this.czddData = res.data;
          this.czddLeftList = res.data.sjzt_jsons.map((item,index)=>{
            return{
              name:item.mc,
              num:item.count||0,
              xzNum:res.data.sjzt_jsons_xz[index].count||0,
            }
          })
        }
      })
    },
    // 处置调度-事件分类
    getCzddSjfl(){
      czddSjfl({}).then(res=>{
        if(res && res.code==200 && res.data){
          this.czddCharData = res.data.sjlx.map(item=>{
            return{
              name:item.mc,
              value:item.count||0,
              num:item.count||0,
              ratio:item.percentage||0,
            }
          })
          this.$refs.czddHxtChartRef.getEchartData(this.czddCharData)
        }
      })
    },
    // 处置调度-事件统计-折线图
    getCzddSjtj(timeType=7){
      // timeType:7,15,30
      czddSjtj({timeType}).then(res=>{
        if(res && res.code==200 && res.data){
          let data = res.data.count_jsons;
          this.$refs.zhexianChartRef.getEchartData(data)
          
        }
      })
    },

    // 基础数据9
    getIndexJcsj9(){
      indexJcsj9({}).then(res=>{
        if(res && res.code==200 && res.data){
          this.jcsjList9.shzzList.forEach((item,index)=>{
            item.num = res.data[item.key];
            this.jcsjList9.zzjgList[index] && (this.jcsjList9.zzjgList[index].num = res.data[this.jcsjList9.zzjgList[index].key]);
            this.jcsjList9.syrkList[index] && (this.jcsjList9.syrkList[index].num = res.data[this.jcsjList9.syrkList[index].key]);
            this.jcsjList9.hjrkList[index] && (this.jcsjList9.hjrkList[index].num =  res.data[this.jcsjList9.hjrkList[index].key]);
          })
        }
      })
    },
    // 基础数据x
    getIndexJcsjx(){
      indexJcsjx({}).then(res=>{
        if(res && res.code==200 && res.data){
          this.jcsjListx.jcsjxLeftList.forEach((item,index)=>{
            item.num = res.data[item.key];
            this.jcsjListx.jcsjxRightList[index].num = res.data[this.jcsjListx.jcsjxRightList[index].key];
          })
        }
      })
    },
    // 风险摸排
    getIndexFxmp(){
      indexFxmp({}).then(res=>{
        if(res && res.code==200 && res.data){
          this.fxmpList.forEach(item=>{
            item.num = res.data[item.key]
          })
          this.slhList.left.forEach((item,index)=>{
            this.slhList.left[index].num = res.data[this.slhList.left[index].key];
            this.slhList.right[index].num = res.data[this.slhList.right[index].key];
          })
        }
      })
    },
    // 数据统计
    getIndexSjtj(timeType=0){
      console.log(timeType,'timeType');
      indexSjtj({timeType}).then(res=>{
        if(res && res.code==200 && res.data){
          this.xxcjTjList.forEach(item=>{
            item.num = res.data[item.key]||0;
          })
          this.tableList = res.data.xz_data_jsons;
        }
      })
    },
   
  }
}
</script>

<style lang="scss" scoped>
.textFillColor {
  // background-image:-webkit-linear-gradient(top,#edffff,#178eff);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-image: -webkit-linear-gradient(top, #edffff, #0c8fd9);
}

.home {
  height: 1080px;
  background-color: #020308;
  font-family: 'AlimamaShuHeiTi-Bold';
  color: #d3d6dd;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    z-index: -1;
    display: block;
    width: 100%;
    height: 100%;
    background-image: url('../../assets/images/home/main.png');
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
  }

  .header {
    position: relative;
    width: 100%;
    height: 116px;
    background-image: url('../../assets/images/newHome/header-bj.png');
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    animation: MoveTopToDown 0.6s ease-in;
    // &::before{
    //   content: '';
    //   position: absolute;
    //   left: 0;
    //   top: 0;
    //   z-index: 999;
    //   width: 100%;
    //   height: 98.5px;
    //   display: block;
    //   background-image: url('../../assets/images/newHome/header-bj-gif.gif');
    //   background-repeat: no-repeat;
    //   background-position: center;
    //   background-size: cover;
    // }
    @keyframes MoveTopToDown {
        0% {
          opacity: 0;
          -webkit-transform: translate3d(0, -100%, 0);
          transform: translate3d(-0, -100%, 0);
        }

        100% {
          opacity: 1;
          -webkit-transform: none;
          transform: none;
        }
      }
    .headContent {
      padding: 0 20px;
      width: 100%;
      height: 54px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 14px;
      .headLeft {
        width: 550px;
        .zzjgt {
          cursor: pointer;
          display: flex;
          align-items: center;
          >img{
            margin-right: 8px;
          }
          >span{
            background-image: -webkit-linear-gradient(top, #13e3ff 0%, #139cff 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
          }
        }
      }

      .headTitle {
        margin-top: 35px;
        text-align: center;
        font-weight: bold;
        font-size: 40px;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-image: -webkit-linear-gradient(bottom, #26d3fa 0%, #ffffff 100%);
      }

      .headRight {
        width: 550px;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        .tz {
          cursor: pointer;
          position: relative;
          width: 24px;
          height: 24px;
          img {
            position: absolute;
            top: 0;
            left: 0;
            width: 24px;
            height: 24px;
          }

          .spot {
            position: absolute;
            top: -7px;
            right: -7px;
            width: 16px;
            height: 16px;
            border-radius: 50%;
            background: red;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 12px;
            font-weight: bold;
          }
        }

        .userName,.tc {
          cursor: pointer;
          margin-left: 40px;
          display: flex;
          align-items: center;
          >img{
            margin-right: 10px;
            width: 24px;
            height: 24px;
            border-radius: 50%;
          }
        }
      }
    }
  }

  .main {
    position: absolute;
    top: 84px;
    left: 0;
    padding: 0 20px;
    width: 100%;
    display: flex;
    justify-content: space-between;

    .commonBox{
      margin-bottom: 10px;
      display: flex;
      flex-direction: column;
      width: 480px;
      border-radius: 4px;
      background: linear-gradient(180deg, #011e3999 0%, #0f3047 100%);
      .commonTitle{
       
        width: 100%;
        height: 40px;
        background-image: url('../../assets/images/newHome/title-bj.png');
        background-repeat: no-repeat;
        background-position: center;
        background-size: cover;
        .titleContent{
          padding: 0 24px;
          width: 100%;
          height: 32px;
          display: flex;
          align-items: center;
          >img{
            width: 28px;
            height: 28px;
            margin-right: 10px;
          }
          >span{
            // height: 32px;
            font-size: 18px;
            font-weight: bold;
          }
        }
      }
      .commonContent{
        flex: 1;
        width: 480px;
      }
    }

    // 党建引领
    .djyl{
      height: 361px;
      animation: yhjcLeftRight 1.3s ease-in-out;
      @keyframes yhjcLeftRight {
        0% {
          opacity: 0;
          -webkit-transform: translate3d(-100%, 0, 0);
          transform: translate3d(-100%, 0 0);
        }

        100% {
          opacity: 1;
          -webkit-transform: none;
          transform: none;
        }
      }
      .djylContent{
        display: flex;
        justify-content: space-between;
        padding: 20px;
        .djylItem {
          width: 210px;
          display: flex;
          flex-direction: column;
          background: linear-gradient(180.04deg, #063d4f33 4.8%, #1fa5ad1a 99.42%);
          .djylTitle {
            padding: 3px 20px 0;
            width: 100%;
            height: 48px;
  
            display: flex;
            align-items: center;
            >img {
              width: 42px;
              height: 42px;
            }
            .djylTitleRight{
              display: flex;
              align-items: center;
              .name{
                width: 45px;
                margin-left: 14px;
                margin-right: 16px;
                font-size: 14px;  
              }
            } 
          }
  
          .djylBottom{
            flex: 1;
            width: 100%;
            display: flex;
            justify-content: center;
          }
        }
      }
    }

    // 综治力量
    .zzll{
      height: 310px;
      animation: jdylLeftRight 1s ease-in-out;
      @keyframes jdylLeftRight {
        0% {
          opacity: 0;
          -webkit-transform: translate3d(-200%, 0, 0);
          transform: translate3d(-200%, 0 0);
        }

        100% {
          opacity: 1;
          -webkit-transform: none;
          transform: none;
        }
      }

      .zzllContent{
        flex:1;
        padding: 20px 10px;
        display: flex;
        flex-direction: column;
        .zzllTitle{
          margin-bottom: 36px;
          height: 34px;
          padding: 0 20px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          .zzjg,.zzdw{
            border-radius: 10px;
            width: 146px;
            height: 100%;
            background-image: url('../../assets/images/newHome/zzjg-bj.png');
            background-repeat: no-repeat;
            background-position: center;
            background-size: cover;

            display: flex;
            align-items: center;
            justify-content: center;
            >span{
              margin-right: 4px;
              color: #ebf5ff;
              font-weight: bold;
              font-size: 16px;
              letter-spacing: 2px;
            }
          }
          .zzdw{
            background-image: url('../../assets/images/newHome/zzdw-bj.png');
            >span{
              margin-left: 4px;
            }
          }
        }
        .zzllBottom{
          flex: 1;
          height: 100%;
          background-image: url('../../assets/images/newHome/zzll-bj.png');
          background-repeat: no-repeat;
          background-position: center;
          background-size: cover;
          display: flex;
          justify-content: space-between;
          align-items: center;

          font-weight: bold;
          font-size: 18px;
          .left{
            // padding-left:29px;
            padding-left:13px;
            width: 145px;
            height: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: space-evenly;
            .leftItem{
              width: 100%;
              display: flex;
              align-items: center;
              justify-content: space-between;
              // margin-bottom: 20px;
              .name{
                font-size: 14px;
              }
              &:first-child{
                // padding-left:16px;
                padding-left:10px;
              }
              &:last-child{
                // padding-left:16px;
                padding-left:10px;
              }
              &:not(:first-child):not(:last-child){
                padding-right: 10px;
              }
            }

          }

          .right{
            // padding-right:29px;
            padding-right:13px;
            width: 145px;
            height: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: space-evenly;
            .rightItem{
              width: 100%;
              display: flex;
              align-items: center;
              justify-content: space-between;
              // margin-bottom: 20px;
              .name{
                font-size: 14px;
              }
              &:first-child{
                // padding-right:16px;
                padding-right:10px;
              }
              &:last-child{
                // padding-right:16px;
                padding-right:10px;
              }
              &:not(:first-child):not(:last-child){
                padding-left: 10px;
              }
            }
           
          }
        }
      }
    }

    // 社会力量
    .shll{
      height: 295px;
      animation: jcsjLeftRight 0.5s ease-in-out;
      @keyframes jcsjLeftRight {
        0% {
          opacity: 0;
          -webkit-transform: translate3d(-300%, 0, 0);
          transform: translate3d(-300%, 0 0);
        }

        100% {
          opacity: 1;
          -webkit-transform: none;
          transform: none;
        }
      }
      .shllContent{
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-wrap: wrap;
        padding: 20px 40px;
        .shllItem{
          width: 50%;
          display: flex;
          align-items: center;
          >img{
            width: 48px;
            height: 49px;
            margin-right: 20px;
          }
          .shllItemRight{
            display: flex;
            flex-direction: column;
            >span{
              font-weight: 500;
              font-size: 20px;
              color: #caf2ff;
              font-weight: 500;
              font-size: 20px;
            }
            >div{
              color: #6dccff;
              font-size: 14px;
            }
          }
        }
      }
    }

    // 基础数据9+X
    .jcsj{
      height: 379px;
      animation: xwdtRightLeft 1.3s ease-in-out;
      @keyframes xwdtRightLeft {
        0% {
          opacity: 0;
          -webkit-transform: translate3d(100%, 0, 0);
          transform: translate3d(100%, 0 0);
        }

        100% {
          opacity: 1;
          -webkit-transform: none;
          transform: none;
        }
      }
      .jcsjContent{
        padding: 0 8px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .jcsj9{
          position: relative;
          padding-top: 20px;
          height: 197px;
          display: flex;
          // align-items: center;

          .jcsj9Item{
            width: 90px;
            // display: flex;
            position: relative;
            top: 22px;
            .list{
              position: absolute;
              top: 0;
              left: 0;

              display: flex;
              flex-direction: column;
              .item{
                position: relative;
                // padding:5px 10px;
                padding:0px 5px;
                width: 71px;
                height: 22px;
                border-radius: 60px;
                box-sizing: border-box;
                display: flex;
                justify-content: space-between;
                align-items: center;
                background-image: url('../../assets/images/newHome/ej-bj.png');
                background-repeat: no-repeat;
                background-position: left;
                background-size: 71px 22px;
                margin-bottom:7px;
                .num{
                  color: #caf2ff;
                  font-weight: 500;
                  font-size: 14px;
                }
                .name{
                  margin-left: 2px;
                  color: #6dccff;
                  font-size: 12px;
                }
                .leftLine{
                  position: absolute;
                  top: 50%;
                  right: -50%;
                  transform: translateX(-65%);
                }
                .rightLine{
                  position: absolute;
                  left: 0;
                }
              }
            }
            >img{
              position: absolute;
              top: 0;
              right: 0px;
              width: 20px;
              height: 140px;
            }
          }

          #jcsj9ItemZzjg{
            width: 116px;
            position: relative;
            top: 0px;
            left: -5px;

            .item{
              width: 90px;
              height: 25px;
              margin-bottom:10px;
              background-image: url('../../assets/images/newHome/yj-bj.png');
              background-size: 90px 25px;
            }
            >img{
              position: absolute;
              top: 0;
              right: 0px;
              width: 26px;
              height: 165px;
            }
          }
          
          .jcsj9Content{
            position: absolute;
            top: 62px;
            left: 50%; 
            transform: translateX(-50%);
            width: 152px;
            height: 110px;
          }
          #jcsj9ItemSyrk{
            width: 114px;
            position: relative;
            top: 18px;
            left: 55px;
            .list{
              position: absolute;
              top: 0;
              right: 0;
              left: auto;

              display: flex;
              flex-direction: column;
              .item{
                width: 90px;
                height: 25px;
                margin-bottom:10px;
                background-image: url('../../assets/images/newHome/yj-bj.png');
                background-size: 90px 25px;
              }
            }
            >img{
              position: absolute;
              z-index:1;
              top: 0;
              left: 0px;
              width: 26px;
              height: 130px;
            }
          }
          #jcsj9ItemHjrk{
            width: 90px;
            position: relative;
            top: 0px;
            left: 53px;
            .list{
              position: absolute;
              top: 0;
              right: 0;
              left: auto;

              display: flex;
              flex-direction: column;
              .item{
                width: 71px;
                height: 22px;
                margin-bottom:5px;
                background-image: url('../../assets/images/newHome/ej-bj.png');
                background-size: 71px 22px;
              }
            }
            >img{
              position: absolute;
              z-index:1;
              top: 0;
              left: 0px;
              width: 20px;
              height: 103px;
            }
          }


        }
        .jcsjLine{
          width: 100%;
          height: 4px;
        }
        .jcsjx{
          position: relative;
          height: 146px;
          padding: 20px 22px 0;
          display: flex;
          .jcsjxItem{
            width: 180px;
            position: relative;
            top: 0px;
            .list{
              position: absolute;
              top: 0;
              left: 0;

              display: flex;
              flex-direction: column;
              .item{
                position: relative;
                // padding:5px 10px;
                padding:0px 10px;
                width: 155px;
                height: 30px;
                // border-radius: 60px;
                box-sizing: border-box;
                display: flex;
                justify-content: space-between;
                align-items: center;
                background-image: url('../../assets/images/newHome/jcsjx/jcsjx-left-bj.png');
                background-repeat: no-repeat;
                background-position: left;
                background-size: 155px 30px;
                margin-bottom:8px;
                .num{
                  color: #caf2ff;
                  font-weight: 500;
                  font-size: 16px;
                }
                .name{
                  margin-left: 2px;
                  color: #6dccff;
                  font-size: 12px;
                }
                
              }
            }
            >img{
              position: absolute;
              top: 0;
              right: 0px;
              width: 26px;
              height: 105px;
            }
          }
          .jcsjxContent{
            position: absolute;
            bottom: 0px;
            left: 50%; 
            transform: translateX(-50%);
            width: 152px;
            height: 108px;
          }

          #jcsjxItemRight{
            left: 60px;
            .list{
              position: absolute;
              top: 0;
              left: auto;
              right: 1px;
              .item{
                background-image: url('../../assets/images/newHome/jcsjx/jcsjx-right-bj.png');
              }
            }
            >img{
              position: absolute;
              top: 0;
              left: 0px;
              z-index:9;
            }
          }
        }
      }
    }

    // 风险摸排
    .fxmp{
      height: 279px;
      animation: wggsRightLeft 1s ease-in-out;
      @keyframes wggsRightLeft {
        0% {
          opacity: 0;
          -webkit-transform: translate3d(200%, 0, 0);
          transform: translate3d(200%, 0 0);
        }

        100% {
          opacity: 1;
          -webkit-transform: none;
          transform: none;
        }
      }
      .pxmpContent{
        padding: 0px 20px;
        .fxmpList{
          display: flex;
          justify-content: space-between;
          flex-wrap: wrap;
          .fxmpListItem{
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 0 20px;
            margin-top: 10px;
            width: 210px;
            height: 36px;
            background-image: url('../../assets/images/newHome/fxmp-item.png');
            background-repeat: no-repeat;
            background-position: left;
            background-size: cover;
            div{
              color: #D7ECFF;
              font-size: 14px;
            }
            span{
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
              background-image: -webkit-linear-gradient(top, #faff13 4.28%, #ffbd13 97.29%);  
              font-weight: bold;
              font-size: 18px;
            }
          }
        }

        .slh{
          margin-top: 6px;
          width: 100%;
          display: flex;
          justify-content: space-between;
          align-items: center;
         
          >img{
            width: 53px;
            height: 76px;
          }
          .slhLeftList,.slhRightList{
            align-self: flex-start;
            .slhListItem{
              margin-top: 12px;
              margin-bottom: 24px;
              width: 101px;
              height: 42px;
              background-image: url('../../assets/images/newHome/slh-left-bj1.png');
              background-repeat: no-repeat;
              background-position: center;
              background-size: cover;
              display: flex;
              flex-direction: column;
              justify-content: flex-end;
              align-items: flex-end;
              >span{
                padding-right: 28px;
                font-weight: bold;
                font-size: 18px;
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
                background-image: -webkit-linear-gradient(top, #ecfcff 42.66%, #52c8e2 89.19%);    
              }
              >div{
                padding-right: 5px;
                font-size: 14px;
                color: #d7ecff;
              }
            }
          }

         
          .slhRightList{
            .slhListItem{
              align-items: flex-start;
              background-image: url('../../assets/images/newHome/slh-right-bj1.png');
              >span{
                padding-left: 28px;
              }
              >div{
                width: 70px;
                text-align: center;
                padding-left: 5px;
              }
            }
          }
          .slhContent{
            width: 116px;
            height: 140px;
            background-image: url('../../assets/images/newHome/slh-content.png');
            // background-image: url('../../assets/images/newHome/slh-gif.gif');
            background-repeat: no-repeat;
            background-position: center;
            background-size: cover;
            display: flex;
            align-items: center;
            justify-content: center;
            font-weight: bold;
            font-size: 20px;
            span{
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
              background-image: -webkit-linear-gradient(top, #edffff 34.48%, #0c9bd9 99.1%);      

            }
          }
        }
      }
    }

   
    // 数据统计
    .sjtj{
      height: 308px;
      animation: xxcjLeftRight 0.5s ease-in-out;
      @keyframes xxcjLeftRight {
        0% {
          opacity: 0;
          -webkit-transform: translate3d(300%, 0, 0);
          transform: translate3d(300%, 0 0);
        }

        100% {
          opacity: 1;
          -webkit-transform: none;
          transform: none;
        }
      }
      .sjtjCommonTitle{
        background-image: url('../../assets/images/newHome/title-bj2.png');
        .sjtjTitleContent{
          padding-left: 24px!important;
          padding-right: 6px!important;
          .sjtjTitleRight{
            margin-bottom: 10px;
            cursor: pointer;
            // width: 156px;
            font-size:12px;
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            background-image: -webkit-linear-gradient(top, #13e3ff 0%, #094278 100%);
            .timeActive{
              font-size:14px;
              background-image: -webkit-linear-gradient(top, #edffff, #0c8fd9);
            }
          }
        }
      }
      .sjtjContent {
        padding: 3px 15px 10px;
        display: flex;
        flex-direction: column;
        // margin-top: 10px;

        .sjtjTj {
          margin-bottom: 10px;
          display: flex;
          justify-content: space-between;

          .sjtjTjItem {
            display: flex;
            align-items: center;
            background-repeat: no-repeat;
            background-position: left;
            background-size: cover;
            >img{
              margin-right: 12px;
            }
            .sjtjTjItemRight{
              span {
                font-size: 12px;
                padding-bottom: 10px;
              }
  
              div {
                margin-top: 3px;
                font-weight: 500;
                font-size: 20px;        
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
              }
            }

            &:nth-child(1){
             background-image: url('../../assets/images/newHome/fws-bj.png');
              .sjtjTjItemRight{
                span{
                  color: #5EC5FF;
                }
                div{
                  background-image: -webkit-linear-gradient(top, #ddeafd 0%, #73cdf4 100%);      
                }
              }
            }
            &:nth-child(2){
              background-image: url('../../assets/images/newHome/rks-bj.png');
              .sjtjTjItemRight{
                span{
                  color: #5EFFF5;
                }
                div{
                  background-image: -webkit-linear-gradient(top, #ddfbfd 0%, #73f4ec 100%);      
                }
              }
            }
            &:nth-child(3){
              background-image: url('../../assets/images/newHome/dws-bj.png');
              .sjtjTjItemRight{
                span{
                  color: #FFDB5E;
                }
                div{
                  background-image: -webkit-linear-gradient(top, #fdfadd 0%, #f4c073 100%);      
                }
              }
            }
          }
        }

        .tableHeader {
          // margin-top: 17px;
          position: relative;
          width: 100%;
          height: 40px;
          background-image: url('../../assets/images/home/xwdtList.png');
          background-repeat: no-repeat;
          background-position: center;
          background-size: cover;
          display: flex;
          justify-content: space-around;
          align-items: center;

          >div {
            width: 25%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
          }
        }

        .tableList {
          height: 160px;
          // height: 195px;
          overflow: auto;

          >div {
            // margin-bottom: 15px;
            margin-bottom: 8px;
            width: 100%;
            height: 32px;
            background-image: url('../../assets/images/home/xwdtList2.png');
            background-repeat: no-repeat;
            background-position: center;
            background-size: cover;

            span {
              width: 25%;
              text-align: center;
            }

            &:last-child {
              margin-bottom: 0px;
            }
          }
        }
      }
    }

    .content{
      width: 860px;
      display: flex;
      flex-direction: column;
      // 地图
      .map{
        flex: 1;
        position: relative;
        margin-bottom: 10px;
        .mapControl {
          cursor: pointer;
          position: absolute;
          z-index: 9;
          top: 22px;
          right: 0;
          display: flex;
          flex-direction: column;
          align-items: flex-end;

          div {
            background-image: url('../../assets/images/home/mapActive.png');
            background-repeat: no-repeat;
            background-position: center;
            background-size: contain;
            height: 30px;
            display: flex;
            justify-content: center;
            align-items: center;
          }

          .mapCurrent,
          .mapCurrent2 {
            position: absolute;
            left: -25px;
            top: 3px;
            width: 25px;
            height: 24px;
            background-image: url('../../assets/images/home/mapCurrent.png');
            background-repeat: no-repeat;
            background-position: center;
            background-size: contain;
          }

          .mapCurrent2 {
            left: -7px;
            top: 43px;
          }
        }
        .mapContent{
          width:100%;
          height:calc(100% - 100px);
          .dldqMap{
            width: 661px;
            height: 507px;
            position: absolute;
            top: -20px;
            left: 50%;
            height: 620px;
            transform: translateX(-50%);
          }
          .mapDz{
            position: relative;
            top: 0;
            left: 0;
            width: 100%;
            height: max-content;
            .mapDzGuang{
              position: absolute;
              z-index: 9;
              width: 510px;
              top: 335px;
              left: 50%;
              transform: translateX(-50%);
            }
            .mapBottom {
              position: absolute;
              top: 45px;
              left: 0px;
              width: 100%;
              animation: rotation 50s infinite linear;
            }
            @keyframes rotation {
              0% {
                transform: rotateX(100deg) rotateY(0deg) rotateZ(0deg);
              }

              100% {
                transform: rotateX(100deg) rotateY(0deg) rotateZ(360deg);
              }
            }
          }

          
          .nqsqMap{
            position: absolute;
            width:100%;
            height:100%;
          }
        }

        .contentTab {
          padding: 0 25px;
          position: relative;
          // z-index: 9;
          // position: absolute;
          bottom: 0;
          width: 100%;
          height: 100px;
          display: flex;
          justify-content: space-evenly;
           background-image: url('../../assets/images/newHome/tabBottom.png');
          background-repeat: no-repeat;
          background-position: bottom;
          background-size: contain;

         

          .tabItem {
            flex: 1;
            margin-bottom: 0px;
            cursor: pointer;
            text-align: center;
            width: 79px;
            height: 87px;
            border-radius: 6px;
            background-image: url('../../assets/images/newHome/tabUnActive.png');
            background-repeat: no-repeat;
            background-position: center;
            background-size: contain;

            display: flex;
            flex-direction: column;
            align-items: center;
            .icon{
              display: block;
              width: 24px;
              height: 24px;
              margin-top: 8px;
              margin-bottom: 5px;
              font-size:24px;
            }
            span {
              font-size: 14px;
              color: #ebf5ff;
            }
            &:hover{
              animation:bottomToTop 1s;
              width: 104px!important;
              height: 99px!important;
              background-image: url('../../assets/images/newHome/tabActive.png')!important;
              .icon{
                color: #6DE1FC;
              }
              span{
                font-size: 16px;
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
                background-image: -webkit-linear-gradient(top, #edffff, #0c8fd9);
              }
            }
            &:not(:hover) {
              animation:topToBottom 1s;
            }
            @keyframes topToBottom {
                from {
                  transform: translateY(-27px);
                }
                to {
                  transform: translateY(0px);
                }
            }
            @keyframes bottomToTop {
                from {
                  transform: translateY(-15px);
                }
                to {
                  transform: translateY(-27px);
                }
            }

            
          }
          .leftJt{
            cursor: pointer;
            position: absolute;
            top:22px;
            left: 0;
            width: 34px;
            height: 40px;
          }
          .rightJt{
            cursor: pointer;
            position: absolute;
            top:22px;
            right: 0;
            width: 34px;
            height: 40px;
          }
        
        }


        
      }
      // 处置调度
      .czdd {
        width: 100%;
        height: 354px;
        animation: czddDownUp 0.8s ease-in-out;
        @keyframes czddDownUp {
          0% {
            opacity: 0;
            -webkit-transform: translate3d(0, 100%, 0);
            transform: translate3d(-0, 100%, 0);
          }

          100% {
            opacity: 1;
            -webkit-transform: none;
            transform: none;
          }

        }
        .czddContent{
          flex: 1;
          padding: 10px 15px;
          display: flex;
          .czddLeft{
            position: relative;
            width: 245px;
            height: 100%;
            background: #0a466d1a;
            box-shadow: 0px 0px 12px #2ca6c140 inset;
            .jzr{
              position: absolute;
              top: 10px;
              right: 8px;
              font-size: 12px;
              color: #44b8fa;
              div{
                margin-top: 4px;
                font-size: 14px;
                color:#EF2431;
              }
            }
            .czddLeftTop{
             display: flex;
             justify-content: center;
              .sjzs{
                width: 158px;
                height: 158px;
                background-image: url('../../assets/images/newHome/sjzs-bj.png');
                background-repeat: no-repeat;
                background-position: center;
                background-size: cover;

                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                
                span{
                  font-size: 40px;
                }
                div{
                  color: #e1fffd;
                  font-size: 14px;
                }
              }
            }
            .czddLeftBottom{
              width: 100%;
              display: flex;
              display: flex;
              flex-wrap: wrap;
              .czddLeftBottomItem{
                margin-bottom: 10px;
                width: 45%;
                height: 56px;
                margin: 5px;
                padding: 0 5px;
                border-left: 2px solid #0f8cff;
                background: #2774bb1a;
                font-size: 12px;

                display: flex;
                justify-content: space-between;
                .left{
                  display: flex;
                  flex-direction: column;
                  justify-content: center;
                  font-size: 12px;
                  span{
                    color: #ebf5ff;
                  }
                  div{
                    margin-top: 4px;
                    color: #24f0e4;
                  }
                }
                .right{
                  display: flex;
                  flex-direction: column;
                  justify-content: center;
                  text-align: right;
                  span{
                    color: #8dd4fc;
                  }
                  div{
                    margin-top: 7px;
                    color: #F02430;
                  }
                }
              }
            }
        
          }

        
          .czddRight {
            flex: 1;
            height: 100%;
            margin-left: 10px;
            height: 100%;
            background: #0a466d1a;
            box-shadow: 0px 0px 12px #2ca6c140 inset;
            display: flex;
            flex-direction: column;
            padding: 8px 10px;
            .czddRightTop{
              height: 132px;
              margin-bottom: 10px;
              background-image: url('../../assets/images/newHome/czdd-right-bj.png');
              background-repeat: no-repeat;
              background-position: center;
              background-size: cover;
            }
            .czddRightBottom{
              flex: 1;
              height: calc(100% - 24px);
              .czddTabs {
                cursor: pointer;
                position: relative;
                z-index: 1;
                float: right;
                display: flex;
                justify-content: space-between;
  
                span {
                  font-size: 12px;
                  text-align: center;
                  width: 79px;
                  height: 24px;
                  line-height: 24px;
                  ;
                  margin-left: 10px;
                  background-image: url('../../assets/images/home/czddUnActive.png');
                  background-repeat: no-repeat;
                  background-position: center;
                  background-size: cover;
                }
              }
            }
          }
        }
      }
    }

  }
}</style>
